import {
  Activity,
  Bell,
  Boxes,
  Building2,
  FileCheck,
  FileText,
  Home,
  LayoutDashboard,
  Rotate3d,
  Settings,
  ShieldCheck,
  TriangleAlert,
  type LucideIcon,
} from 'lucide-react'

export type Role = 'assessor' | 'underwriter' | 'insurer' | 'owner'

export const ROLES: { id: Role; name: string; initials: string; blurb: string }[] = [
  { id: 'assessor', name: 'Risk Assessor', initials: 'RA', blurb: 'Full read / write' },
  { id: 'underwriter', name: 'Underwriter', initials: 'UW', blurb: 'Read + annotate' },
  { id: 'insurer', name: 'Insurer / Client', initials: 'IC', blurb: 'Read-only own sites' },
  { id: 'owner', name: 'Asset Owner', initials: 'AO', blurb: 'SCADA + own site' },
]

const ALL: Role[] = ['assessor', 'underwriter', 'insurer', 'owner']

export type NavLink = { to: string; label: string; icon: LucideIcon; roles: Role[]; badge?: string }
export type SiteNavItem = { seg: string; label: string; icon: LucideIcon; roles: Role[]; badge?: string }

export const GLOBAL_NAV: NavLink[] = [
  { to: '/home', label: 'Home', icon: Home, roles: ALL },
  { to: '/portfolio', label: 'Portfolio', icon: Building2, roles: ['assessor', 'underwriter', 'insurer'] },
]

// Rendered relative to /site/:siteId (empty seg = overview).
export const SITE_NAV: SiteNavItem[] = [
  { seg: '', label: 'Overview', icon: LayoutDashboard, roles: ALL },
  { seg: 'assets', label: 'Assets', icon: Boxes, roles: ALL },
  { seg: 'assessment', label: 'Assessment', icon: FileText, roles: ['assessor'] },
  { seg: 'evidence', label: 'Evidence', icon: FileCheck, roles: ['assessor', 'underwriter'] },
  { seg: 'underwriting', label: 'Underwriting', icon: ShieldCheck, roles: ALL },
  { seg: 'obligations', label: 'Obligations', icon: TriangleAlert, roles: ['assessor', 'underwriter', 'owner'] },
  { seg: 'operations', label: 'Operations', icon: Activity, roles: ALL },
  { seg: 'twin', label: '3D Twin', icon: Rotate3d, roles: ALL },
]

export const FOOTER_NAV: NavLink[] = [
  { to: '/alerts', label: 'Alerts', icon: Bell, roles: ['assessor', 'underwriter', 'owner'], badge: '3' },
  { to: '/admin', label: 'Admin', icon: Settings, roles: ['assessor'] },
]
